export const seoMessages = {
  title: {
    info_description:
      "Es la frase clave que resume tu propiedad con no más de 60 caracteres. Usa palabras como ‘venta,’ ‘casa,’ y la ubicación. Ejemplo: ‘Venta de Apartamentos en Santo Domingo Oeste."
  },
  description: {
    info_description:
      '"Describe tu propiedad en detalle y de forma amplia. Incluyendo sus características. como número de habitaciones, ubicación y características únicas. Ejemplo: ‘Casa 3 dormitorios, 2 parqueos, vista panorámica, jardín amplio en Pantoja, Santo Domingo Oeste."'
  },
  short_description: {
    info_description:
      "Es un resumen corto en los resultados de búsqueda de máximo 160 caracteres. Sé claro y atractivo. Ejemplo: ‘Encuentra tu hogar ideal en Santo Domingo Oeste. Explora apartamentos en venta ahora."
  },
  key_works: {
    info_description:
      "Las palabras clave son términos importantes para buscar propiedades. Se recomienda definir  mínimo 10 palabras clave. Ejemplos: ’Venta de casas, bienes raíces, Santo Domingo Oeste, casa de lujo, apartamento en venta en Santo Domingo Oeste, apartamentos con fideicomiso."
  },
  preview_browser: {
    info_description:
      "Esta es una muestra de como se visualizaría la información en los buscadores."
  }
};

export const msgSeoLoading = [
  "La magia está en proceso, esto tomará alrededor de 10 segundos.",
  "Prioriza palabras claves para una mejor búsqueda.",
  "Promociona las propiedades que quieres que sean conocidas.",
  "Los clientes van evolucionando, adapta tu estrategia a ellos."
];
